export enum EQuickSortKey {
  ACCOUNT = 'account',
  SITE = 'site',
  ID = 'id',
  FLAG = 'flag',
  CREATED_BY = 'created by',
  CREATED = 'created',
  UPDATED = 'updated',
}

export enum EQuickSortTranslatedKey {
  ACCOUNT = 'accountName',
  SITE = 'siteName',
  ID = 'sequenceNumber',
  FLAG = 'flagged',
  CREATED_BY = 'header.createdBy.id',
  CREATED = 'header.createdDate',
  UPDATED = 'header.updatedDate',
}
